/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const whatsAppAiActivityStateSchema = z.enum(['idle', 'queued', 'thinking'])

export type WhatsAppAiActivityStateSchema = z.infer<typeof whatsAppAiActivityStateSchema>
